import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var _excluded = ["actionSubjectId"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { name as packageName, version as packageVersion } from '../../version.json';
import { getMeasure } from '../performance';
export var ANALYTICS_CHANNEL = 'media';
export var context = {
  componentName: 'smart-cards',
  packageName: packageName,
  packageVersion: packageVersion
};
var uiActionSubjectIds = {
  DownloadAction: 'downloadDocument',
  PreviewAction: 'invokePreviewScreen',
  ViewAction: 'shortcutGoToLink',
  StatusAction: 'issueStatusUpdate'
};
export var SmartLinkEvents = /*#__PURE__*/function () {
  function SmartLinkEvents() {
    _classCallCheck(this, SmartLinkEvents);
  }
  _createClass(SmartLinkEvents, [{
    key: "insertSmartLink",
    value: function insertSmartLink(url, type, createAnalyticsEvent) {
      fireSmartLinkEvent({
        action: 'inserted',
        actionSubject: 'smartLink',
        eventType: 'track',
        attributes: {
          type: type
        },
        nonPrivacySafeAttributes: {
          domainName: url
        }
      }, createAnalyticsEvent);
    }
  }]);
  return SmartLinkEvents;
}();
export var fireSmartLinkEvent = function fireSmartLinkEvent(payload, createAnalyticsEvent) {
  if (createAnalyticsEvent) {
    createAnalyticsEvent(payload).fire(ANALYTICS_CHANNEL);
  }
};
export var resolvedEvent = function resolvedEvent(props) {
  return {
    action: 'resolved',
    actionSubject: 'smartLink',
    eventType: 'operational',
    attributes: _objectSpread(_objectSpread({}, props), context)
  };
};
export var unresolvedEvent = function unresolvedEvent(_ref) {
  var id = _ref.id,
    definitionId = _ref.definitionId,
    extensionKey = _ref.extensionKey,
    resourceType = _ref.resourceType,
    destinationSubproduct = _ref.destinationSubproduct,
    destinationProduct = _ref.destinationProduct,
    error = _ref.error,
    status = _ref.status,
    location = _ref.location;
  return {
    action: 'unresolved',
    actionSubject: 'smartLink',
    eventType: 'operational',
    attributes: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      id: id
    }, context), definitionId ? {
      definitionId: definitionId
    } : {}), extensionKey ? {
      extensionKey: extensionKey
    } : {}), resourceType ? {
      resourceType: resourceType
    } : {}), destinationSubproduct ? {
      destinationSubproduct: destinationSubproduct
    } : {}), destinationProduct ? {
      destinationProduct: destinationProduct
    } : {}), location ? {
      location: location
    } : {}), {}, {
      reason: status,
      error: error ? {
        message: error === null || error === void 0 ? void 0 : error.message,
        kind: error === null || error === void 0 ? void 0 : error.kind,
        type: error === null || error === void 0 ? void 0 : error.type
      } : undefined
    })
  };
};
export var invokeSucceededEvent = function invokeSucceededEvent(_ref2) {
  var id = _ref2.id,
    actionType = _ref2.actionType,
    display = _ref2.display,
    extensionKey = _ref2.extensionKey,
    definitionId = _ref2.definitionId,
    destinationProduct = _ref2.destinationProduct,
    destinationSubproduct = _ref2.destinationSubproduct,
    location = _ref2.location;
  var measure = getMeasure(id, 'resolved') || {
    duration: undefined
  };
  return {
    action: 'resolved',
    actionSubject: 'smartLinkAction',
    eventType: 'operational',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      actionType: actionType,
      display: display,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      extensionKey: extensionKey,
      duration: measure.duration
    })
  };
};
export var invokeFailedEvent = function invokeFailedEvent(_ref3) {
  var id = _ref3.id,
    actionType = _ref3.actionType,
    display = _ref3.display,
    reason = _ref3.reason,
    extensionKey = _ref3.extensionKey,
    definitionId = _ref3.definitionId,
    destinationProduct = _ref3.destinationProduct,
    destinationSubproduct = _ref3.destinationSubproduct,
    location = _ref3.location;
  var measure = getMeasure(id, 'errored') || {
    duration: undefined
  };
  return {
    action: 'unresolved',
    actionSubject: 'smartLinkAction',
    eventType: 'operational',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      actionType: actionType,
      display: display,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      duration: measure.duration,
      reason: reason
    })
  };
};
export var connectSucceededEvent = function connectSucceededEvent(_ref4) {
  var definitionId = _ref4.definitionId,
    extensionKey = _ref4.extensionKey,
    destinationProduct = _ref4.destinationProduct,
    destinationSubproduct = _ref4.destinationSubproduct,
    location = _ref4.location;
  return {
    action: 'connectSucceeded',
    actionSubject: 'smartLink',
    eventType: 'operational',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      definitionId: definitionId,
      extensionKey: extensionKey,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    })
  };
};
export var connectFailedEvent = function connectFailedEvent(_ref5) {
  var definitionId = _ref5.definitionId,
    extensionKey = _ref5.extensionKey,
    destinationProduct = _ref5.destinationProduct,
    destinationSubproduct = _ref5.destinationSubproduct,
    location = _ref5.location,
    reason = _ref5.reason;
  return {
    action: 'connectFailed',
    actionSubject: 'smartLink',
    actionSubjectId: reason,
    eventType: 'operational',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      reason: reason,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    })
  };
};
export var trackAppAccountConnected = function trackAppAccountConnected(_ref6) {
  var definitionId = _ref6.definitionId,
    extensionKey = _ref6.extensionKey,
    destinationProduct = _ref6.destinationProduct,
    destinationSubproduct = _ref6.destinationSubproduct,
    location = _ref6.location;
  return {
    action: 'connected',
    actionSubject: 'applicationAccount',
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      definitionId: definitionId,
      extensionKey: extensionKey,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    })
  };
};
export var trackAppAccountAuthStarted = function trackAppAccountAuthStarted(_ref7) {
  var extensionKey = _ref7.extensionKey,
    location = _ref7.location;
  return {
    action: 'authStarted',
    actionSubject: 'applicationAccount',
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      extensionKey: extensionKey,
      location: location
    })
  };
};
export var trackLinkUpdated = function trackLinkUpdated(_ref8) {
  var actionSubjectId = _ref8.actionSubjectId,
    attributes = _objectWithoutProperties(_ref8, _excluded);
  return {
    action: 'updated',
    actionSubject: 'link',
    actionSubjectId: actionSubjectId,
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, context), attributes)
  };
};
export var uiAuthEvent = function uiAuthEvent(_ref9) {
  var definitionId = _ref9.definitionId,
    extensionKey = _ref9.extensionKey,
    destinationProduct = _ref9.destinationProduct,
    destinationSubproduct = _ref9.destinationSubproduct,
    location = _ref9.location,
    display = _ref9.display;
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'connectAccount',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      definitionId: definitionId,
      extensionKey: extensionKey,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      display: display
    })
  };
};
export var uiAuthAlternateAccountEvent = function uiAuthAlternateAccountEvent(_ref10) {
  var definitionId = _ref10.definitionId,
    extensionKey = _ref10.extensionKey,
    destinationProduct = _ref10.destinationProduct,
    destinationSubproduct = _ref10.destinationSubproduct,
    location = _ref10.location,
    display = _ref10.display;
  return {
    action: 'clicked',
    actionSubject: 'smartLink',
    actionSubjectId: 'tryAnotherAccount',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      definitionId: definitionId,
      extensionKey: extensionKey,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      display: display
    })
  };
};
export var uiCardClickedEvent = function uiCardClickedEvent(_ref11) {
  var id = _ref11.id,
    display = _ref11.display,
    status = _ref11.status,
    definitionId = _ref11.definitionId,
    extensionKey = _ref11.extensionKey,
    isModifierKeyPressed = _ref11.isModifierKeyPressed,
    location = _ref11.location,
    destinationProduct = _ref11.destinationProduct,
    destinationSubproduct = _ref11.destinationSubproduct,
    actionSubjectId = _ref11.actionSubjectId;
  return {
    action: 'clicked',
    actionSubject: 'smartLink',
    actionSubjectId: actionSubjectId,
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      status: status,
      definitionId: definitionId,
      extensionKey: extensionKey,
      display: display,
      isModifierKeyPressed: isModifierKeyPressed,
      location: location,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct
    })
  };
};
export var uiIframeDwelledEvent = function uiIframeDwelledEvent(_ref12) {
  var id = _ref12.id,
    display = _ref12.display,
    status = _ref12.status,
    definitionId = _ref12.definitionId,
    extensionKey = _ref12.extensionKey,
    location = _ref12.location,
    destinationProduct = _ref12.destinationProduct,
    destinationSubproduct = _ref12.destinationSubproduct,
    dwellTime = _ref12.dwellTime,
    dwellPercentVisible = _ref12.dwellPercentVisible;
  return {
    action: 'dwelled',
    actionSubject: 'smartLinkIframe',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      status: status,
      definitionId: definitionId,
      extensionKey: extensionKey,
      display: display,
      location: location,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      dwellTime: dwellTime,
      dwellPercentVisible: dwellPercentVisible
    })
  };
};
export var uiIframeFocusedEvent = function uiIframeFocusedEvent(_ref13) {
  var id = _ref13.id,
    display = _ref13.display,
    status = _ref13.status,
    definitionId = _ref13.definitionId,
    extensionKey = _ref13.extensionKey,
    location = _ref13.location,
    destinationProduct = _ref13.destinationProduct,
    destinationSubproduct = _ref13.destinationSubproduct;
  return {
    action: 'focused',
    actionSubject: 'smartLinkIframe',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      status: status,
      definitionId: definitionId,
      extensionKey: extensionKey,
      display: display,
      location: location,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct
    })
  };
};
export var uiActionClickedEvent = function uiActionClickedEvent(_ref14) {
  var id = _ref14.id,
    actionType = _ref14.actionType,
    extensionKey = _ref14.extensionKey,
    display = _ref14.display,
    definitionId = _ref14.definitionId,
    destinationProduct = _ref14.destinationProduct,
    destinationSubproduct = _ref14.destinationSubproduct,
    location = _ref14.location;
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: uiActionSubjectIds[actionType],
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      display: display,
      actionType: actionType,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    })
  };
};
export var uiClosedAuthEvent = function uiClosedAuthEvent(_ref15) {
  var display = _ref15.display,
    extensionKey = _ref15.extensionKey,
    definitionId = _ref15.definitionId,
    destinationProduct = _ref15.destinationProduct,
    destinationSubproduct = _ref15.destinationSubproduct,
    location = _ref15.location;
  return {
    action: 'closed',
    actionSubject: 'consentModal',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      display: display
    })
  };
};
export var screenAuthPopupEvent = function screenAuthPopupEvent(_ref16) {
  var extensionKey = _ref16.extensionKey,
    definitionId = _ref16.definitionId,
    destinationProduct = _ref16.destinationProduct,
    destinationSubproduct = _ref16.destinationSubproduct,
    location = _ref16.location;
  return {
    actionSubject: 'consentModal',
    eventType: 'screen',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    })
  };
};
export var uiRenderSuccessEvent = function uiRenderSuccessEvent(_ref17) {
  var display = _ref17.display,
    status = _ref17.status,
    extensionKey = _ref17.extensionKey,
    definitionId = _ref17.definitionId,
    destinationProduct = _ref17.destinationProduct,
    destinationSubproduct = _ref17.destinationSubproduct,
    location = _ref17.location;
  return {
    action: 'renderSuccess',
    actionSubject: 'smartLink',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      status: status,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      display: display
    })
  };
};
export var uiRenderFailedEvent = function uiRenderFailedEvent(_ref18) {
  var display = _ref18.display,
    error = _ref18.error,
    errorInfo = _ref18.errorInfo,
    extensionKey = _ref18.extensionKey,
    definitionId = _ref18.definitionId,
    destinationProduct = _ref18.destinationProduct,
    destinationSubproduct = _ref18.destinationSubproduct,
    location = _ref18.location;
  return {
    actionSubject: 'smartLink',
    action: 'renderFailed',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      error: error,
      errorInfo: errorInfo,
      display: display,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    })
  };
};
export var uiHoverCardViewedEvent = function uiHoverCardViewedEvent(_ref19) {
  var id = _ref19.id,
    previewDisplay = _ref19.previewDisplay,
    extensionKey = _ref19.extensionKey,
    definitionId = _ref19.definitionId,
    destinationProduct = _ref19.destinationProduct,
    destinationSubproduct = _ref19.destinationSubproduct,
    location = _ref19.location,
    previewInvokeMethod = _ref19.previewInvokeMethod,
    status = _ref19.status;
  return {
    action: 'viewed',
    actionSubject: 'hoverCard',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      previewDisplay: previewDisplay,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      previewInvokeMethod: previewInvokeMethod,
      status: status
    })
  };
};
export var uiHoverCardDismissedEvent = function uiHoverCardDismissedEvent(_ref20) {
  var id = _ref20.id,
    previewDisplay = _ref20.previewDisplay,
    hoverTime = _ref20.hoverTime,
    extensionKey = _ref20.extensionKey,
    definitionId = _ref20.definitionId,
    destinationProduct = _ref20.destinationProduct,
    destinationSubproduct = _ref20.destinationSubproduct,
    location = _ref20.location,
    previewInvokeMethod = _ref20.previewInvokeMethod,
    status = _ref20.status;
  return {
    action: 'dismissed',
    actionSubject: 'hoverCard',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      previewDisplay: previewDisplay,
      hoverTime: hoverTime,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      previewInvokeMethod: previewInvokeMethod,
      status: status
    })
  };
};
export var uiHoverCardOpenLinkClickedEvent = function uiHoverCardOpenLinkClickedEvent(_ref21) {
  var id = _ref21.id,
    previewDisplay = _ref21.previewDisplay,
    extensionKey = _ref21.extensionKey,
    definitionId = _ref21.definitionId,
    destinationProduct = _ref21.destinationProduct,
    destinationSubproduct = _ref21.destinationSubproduct,
    location = _ref21.location,
    previewInvokeMethod = _ref21.previewInvokeMethod;
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'shortcutGoToLink',
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      id: id,
      previewDisplay: previewDisplay,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location,
      previewInvokeMethod: previewInvokeMethod
    })
  };
};
export var uiLearnMoreLinkClickedEvent = function uiLearnMoreLinkClickedEvent() {
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'learnMore',
    eventType: 'ui',
    attributes: _objectSpread({}, context)
  };
};
export var chunkloadFailedEvent = function chunkloadFailedEvent(_ref22) {
  var display = _ref22.display,
    error = _ref22.error,
    errorInfo = _ref22.errorInfo,
    extensionKey = _ref22.extensionKey,
    definitionId = _ref22.definitionId,
    destinationProduct = _ref22.destinationProduct,
    destinationSubproduct = _ref22.destinationSubproduct,
    location = _ref22.location;
  return {
    action: 'chunkLoadFailed',
    actionSubject: 'smartLink',
    eventType: 'operational',
    attributes: _objectSpread(_objectSpread({}, context), {}, {
      error: error,
      errorInfo: errorInfo,
      display: display,
      extensionKey: extensionKey,
      definitionId: definitionId,
      destinationProduct: destinationProduct,
      destinationSubproduct: destinationSubproduct,
      location: location
    })
  };
};